import React, { useState, useEffect } from 'react';

// Search filter form component
const SearchComponent = ({ onFilterChange }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [serialNumber, setSerialNumber] = useState('');

    useEffect(() => {
        onFilterChange(startDate, endDate, serialNumber);
    }, [startDate, endDate, serialNumber, onFilterChange]);

    return (
        <div className="Search">
            <div class="container">
                <br />
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-xs-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Start Date</label>
                                    <input type="date" class="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} placeholder="Start Date" />
                                </div>
                                <div class="form-group">
                                    <label>End Date</label>
                                    <input type="date" class="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} placeholder="End Date" />
                                </div>
                                <div class="form-group">
                                    <label>Serial Number</label>
                                    <input type="text" class="form-control" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} placeholder="Serial Number" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchComponent;